import { SubmissionError } from "redux-form";
import { FORM_ERROR } from "final-form";

export const useFormLoadErrors = <
  Handler extends (formData: any, ...rest: any[]) => any,
>(
  handler: Handler,
): Handler => {
  return (async (formData: any, ...rest: any[]) => {
    if (!formData) {
      return {};
    }

    try {
      return await handler(formData, ...rest);
    } catch (ex) {
      if (ex instanceof SubmissionError) {
        const { _error, ...errors } = ex.errors;
        return {
          [FORM_ERROR]: _error,
          ...errors,
        };
      } else {
        return {};
      }
    }
  }) as Handler;
};
